import z from 'zod';

const financingsFilterSchema = z.object({
  cursor: z.string()
    .default('')
    .optional(),
  customer_document: z.string()
    .default('')
    .optional(),
  customer_name: z.string()
    .default('')
    .optional(),
  financing_id: z.number()
    .optional(),
  is_battery: z.union([z.boolean(), z.null()])
    .default(null)
    .optional(),
  is_combo: z.union([z.boolean(), z.null()])
    .default(null)
    .optional(),
  partner_document: z.string()
    .default('')
    .optional(),
  partner_id: z.number()
    .optional(),
  person_type: z.string()
    .default('')
    .optional(),
  project_id: z.string()
    .default('')
    .optional(),
  reassessment: z.union([z.boolean(), z.null()])
    .default(null)
    .optional(),
  responsible_id: z.number()
    .optional(),
  statuses: z.string()
    .default('')
    .optional(),
  steps: z.string()
    .default('')
    .optional(),
});

export default financingsFilterSchema;
export type FinancingsFilter = z.infer<typeof financingsFilterSchema>;
